import { defineStore } from 'pinia'

import type { ListsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useListsStore = defineStore('lists', {
  state: (): ListsStore => ({
    lists: null,
    _hydrated: false,
  }),
  actions,
  getters,
})
